import { render, staticRenderFns } from "./toten-de-atendimento.vue?vue&type=template&id=0010ce8b&"
import script from "./toten-de-atendimento.vue?vue&type=script&lang=js&"
export * from "./toten-de-atendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports